"use client";
import styles from "../page.module.scss";
import "@/src/style/post.css";
import PostDetail from "@/src/component/detail/post-detail";
import { Breadcrumb } from "antd";
import Link from "next/link";
import "suneditor/dist/css/suneditor.min.css";

export default function Post({ data, type, clinic_slug }) {
  const dataPost = data?.post;
  const clinic = data?.clinic;
  const doctor = data?.doctor;
  const avatar = clinic ? clinic.image[0] : doctor?.image[0];

  return (
    <>
      <div className={styles.wpDetailListPost}>
        <h1 style={{ display: "none" }}>CHI TIẾT TIN TỨC</h1>
        <div className={styles.nav}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link href="/">Trang Chủ</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                href={
                  clinic
                    ? `/phong-kham/${clinic?.slug}`
                    : type == "CLINIC"
                    ? `/phong-kham/${clinic_slug}/${doctor?.slug}`
                    : `/bac-si/${doctor?.slug}/`
                }
              >
                {clinic ? clinic?.name : doctor?.name}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                href={
                  clinic
                    ? `/phong-kham/${clinic?.slug}/tin-tuc`
                    : type == "CLINIC"
                    ? `/phong-kham/${clinic_slug}/${doctor?.slug}/hoat-dong`
                    : `/bac-si/${doctor?.slug}/hoat-dong`
                }
              >
                {clinic ? "Tin Tức" : "Hoạt động"}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.wpBodyPost}>
          <PostDetail
            item={dataPost}
            clinicAvatar={avatar}
            clinicName={clinic ? clinic?.name : doctor?.name}
          />
        </div>
      </div>
    </>
  );
}
